export const DESCRIPTION_CHARACTER_LIMIT = 25000
export const DESCRIPTION_HISTORY_CHARACTER_LIMIT = 32000
export const SI_MAINTENANCE = [
  { label: 'ECE', value: 'ECE' },
  { label: 'WDH', value: 'WDH' },
  { label: 'APIM', value: 'APIM' },
  { label: 'GED', value: 'GED' },
  { label: "C'CAP", value: "C'CAP" },
  { label: 'NH', value: 'NH' },
  { label: 'Autre', value: 'Autre' },
]

export const chartParams = {
  all: {
    label: 'Globale',
    backgroundColor: '#FABA9B',
  },
  demands_details: {
    label: 'Détails demande',
    backgroundColor: '#BBDCFD',
  },
  ged: {
    label: 'Téléchargement de documents',
    backgroundColor: '#FFC229',
  },
  demands: {
    label: 'Gestion demande',
    backgroundColor: '#AADC14',
  },
  create_users: {
    label: "Création d'un utilisateur",
    backgroundColor: '#2F4474',
  },
}

export const chartOptions = {
  plugins: {
    legend: {
      position: 'bottom' as const,
    },
    datalabels: {
      display: true,
      align: 'center' as const,
      anchor: 'center' as const,
      formatter: (value: number, context) =>
        `${context.dataset.minutes[0]} min`,
      color: '#000',
      font: {
        weight: 'bold',
      },
    },
    tooltip: {
      yAlign: 'bottom',
      callbacks: {
        label: (context) => context.dataset.label,
        afterBody: (context) => {
          const minutes = context[0].dataset.minutes[0]
          const percentage = context[0].dataset.data[0]
          return [`Minutes : ${minutes} min`, `Pourcentage : ${percentage}%`]
        },
      },
      bodySpacing: 5,
    },
  },
  indexAxis: 'y',
  maintainAspectRatio: false,
  responsive: true,
  scales: {
    x: {
      stacked: true,
      ticks: {
        callback: (value: string) => `${value}%`,
      },
    },
    y: {
      stacked: true,
      ticks: {
        display: false,
      },
    },
  },
  datasets: {
    bar: {
      barThickness: 50,
    },
  },
}

export const stackChartLabels = [
  "Création d'un utilisateur",
  'Détails demande',
  'Gestion demande',
  'Globale',
  'Téléchargement de documents',
]

export const stackChartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'right',
      labels: {
        usePointStyle: true,
        pointStyle: 'rect',
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          const minutes = context.dataset.actual?.[context.dataIndex]
          if (!minutes) return ''
          const percent = context.raw.toFixed(1)
          return `${context.dataset.label}: ${minutes} min (${percent}%)`
        },
      },
    },
    datalabels: {
      display: (context) => context.dataset.actual?.[context.dataIndex] !== 0,
      formatter: (value, context) => {
        const minutes = context.dataset.actual?.[context.dataIndex]
        return minutes ? `${minutes} min` : ''
      },
      color: '#000',
      anchor: 'center',
      align: 'center',
      font: {
        weight: 'bold',
      },
    },
  },
  scales: {
    y: {
      stacked: true,
      max: 100,
      ticks: {
        callback: (val) => `${val}%`,
      },
    },
    x: {
      stacked: true,
      grid: { display: false },
    },
  },
}
